import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { debounce } from 'lodash'

const DEBOUNCE_TIME = 400

const Scrolling = ({ as = 'div', children, onScrollEnd = () => {}, ...props }) => {
  const Tag = as
  const [scrollHeight, setScrollHeight] = useState(0)
  const debouncedScroll = debounce(() => onScrollEnd(), DEBOUNCE_TIME, { leading: true })
  const trackScrolling = (e) => {
    const obj = e.target
    const bottom = obj.scrollHeight - obj.scrollTop - obj.clientHeight < 1

    // reset when clear the records
    if (obj.scrollHeight < scrollHeight) {
      setScrollHeight(0)
      e.target.scrollTop = 0
      return false
    }

    // save scroll height to check it recorde reset
    setScrollHeight(e.target.scrollHeight)

    // if scroll on the bottom
    if (bottom) {
      debouncedScroll()
    }
    return true
  }

  return (
    <Tag
      {...props}
      onScroll={trackScrolling}
    >
      {children}
    </Tag>
  )
}

Scrolling.propTypes = {
  as: PropTypes.string,
  children: PropTypes.node,
  fallback: PropTypes.node,
  onScrollEnd: PropTypes.func,
}

export default Scrolling
